import axios from 'axios'
import {responseEnum} from "../../serverClientShared/sharedEnums";
import {isMacOs} from "react-device-detect"
import Settings from "../../settings.json";
import {generalStore} from "../../index";

const url = Settings.isNative ? Settings.frontlineArServer : "";

export class GeneralRequester {

    static async getIsUserSSO(email, deviceLoginCode) {
        const result = await axios.post(`${url}/users/get-sso-login-url`, {
            email,
            deviceLoginCode
        });
        return result.data
    }
    static async checkPermissions(workspace, permissionKey, accessScope) {
        return await axios.post(`${url}/domains/${workspace}/check-permissions`, {permissionKey, accessScope});
    }

    static async checkToManyLoginAttempts(email) {
        const result = await axios.post(`${url}/users/check-to-many-login-attempts`, {
            email
        });
        return result.data
    }

    static async getSubWorkspaceDisplayName(workspace) {
        const result = await axios.get(`${url}/domains/${workspace}/get-sub-workspace-display-name`);
        return result.data
    }

    static async getDomains(email, password, ssoAuth, hpUserType, ssoAccessToken, verificationResult= '') {
        const result = await axios.post(`${url}/users/get-domains`, {
            email,
            password,
            ssoAuth,
            hpUserType,
            ssoAccessToken,
            verificationResult
        });
        return result.data
    }

    async changeEmail(oldEmail, newEmail, isHp) {
        const request = {
            oldEmail, newEmail, isHp
        };
        const result = await axios.post(`${url}/users/change-email`, request);
        return result.status
    }

    static async checkDomainLegal(isNewDomain, domain) {
        const result = await axios.post(`${url}/users/check-domain`, {isNewDomain, domain}); // TODO - defend maybe
        return result.data;
    }

    static async createPendingUser(email, firstName, lastName) {
        const result = await axios.post(`${url}/users/create-pending-user`, {
            email, firstName, lastName
        });
        return result.data
    }

    static async resendVerificationCode(email) {
        const result = await axios.post(`${url}/users/resend-verification-code`, {
            email
        });
        return result.data
    }

    async finishChangeEmail(userId) {
        const result = await axios.put(`${url}/users/finish-change-email/${userId}`, null);
        return result.data
    }

    static async deleteUser(id, domain) {
        const result = await axios.delete(`${url}/users/${domain}/${id}`);
        return result.status
    }

    static async canDeleteAccount(domain) {
        const result = await axios.get(`${url}/users/can-delete-account/${domain}`);
        return result.data;
    }

    static async loginDevice(code, email, password, workspace, isNewDomain, ssoAccessToken, isHpCustomer, ssoAuth, firstName, lastName) {
        await axios.post(`${url}/users/login-device`, {
            code, email, password, workspace, isNewDomain, ssoAccessToken, isHpCustomer, ssoAuth, firstName, lastName
        });
    }

    static async logIn(email, password, isChangeEmail, deviceType, domain, isNewDomain, ssoAccessToken, isHpCustomer, ssoAuth, firstName, lastName) {
        const result = await axios.post(`${url}/users/login/`, {
            email,
            password,
            isChangeEmail,
            deviceType,
            domain,
            isNewDomain,
            ssoAccessToken,
            isHpCustomer,
            ssoAuth,
            firstName,
            lastName
        });
        return result.data
    }

    static async updateUser(user) {
        const result = await axios.post(`${url}/users/update-user`, user);
        return result.status
    }

    static async signup(email, password, firstName, lastName, domain, isNewDomain, deviceType) {
        const result = await axios.post(`${url}/users/register`, {
            email, password, firstName, lastName, domain, isNewDomain, deviceType
        });
        return result.data
    }

    static async resetPassword(email, verificationResult) {
        await axios.post(`${url}/users/ResetPassword`, {
            email,
            verificationResult
        },
            {
                headers: {
                    'Web': true
                }
            });
    }

    static async updatePassword(signInData, token) {
        await axios.put(`${url}/users/UpdatePassword`, {
            password: signInData.password,
            token
        });
    }

    static async deployWorkspace(workspace, projectIdsList) {
        const result = await axios.put(`${url}/domains/${workspace}/deploy-workspace`, {
            projectIdsList
        });
        return result.data
    }

    static async getDeployStatus(workspace) {
        const result = await axios.get(`${url}/domains/${workspace}/get-deploy-status`);
        return result.data
    }

    static async getSelfUserDetails() {
        const result = await axios.get(`${url}/users/get-self`);
        return result.data
    }

    static async globalSearch(term, workspace) {
        const result = await axios.post(`${url}/GlobalSearch/${workspace}/knowledgebase-search`, {
            searchTerm: term
        });
        return result.data;
    }

    static async getCSV(db, workspaceKey, exportData, fromDate, toDate, isLive) {
        const result = await axios.post(`${url}/power-bi/${db}/get-data-csv`, {
            db,
            workspaceKey,
            exportData,
            fromDate,
            toDate,
            isLive
        });
        return result.data;
    }

    static async globalSearchAccess(workspace) {
        const result = await axios.get(`${url}/GlobalSearch/${workspace}/getAccess`);
        return result.data;
    }

    static async globalSearchCleanCache(workspace) {
        const result = await axios.get(`${url}/GlobalSearch/${workspace}/cleanCache`);
        return result.data;
    }

    static async globalSearchGetFullPath(workspace, folderId) {
        const result = await axios.get(`${url}/GlobalSearch/${workspace}/getFullPath/${folderId}`);
        return result.data;
    }

    async getUserById(id, domain) {
        if (!id) {
            return null;
        }
        const result = await axios.post(`${url}/users/${domain}/GetUserById/${id}`);
        return result.data
    }

    static async uploadFileAndThumbnailLocal(formData, domain) {
        const result = await axios.post(`${url}/FileIO/${domain}/UploadFileAndThumbnailLocal`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        return result.data;
    }

    static async getSignedUploadUrl(fileName, withThumbnail, storageFolderName, domain, projectId, isReplace, isAiFile) {
        const result = await axios.post(`${url}/FileIO/${domain}/SignUploadUrl`, {
            fileName,
            withThumbnail,
            storageFolderName,
            projectId,
            isReplace,
            isAiFile
        });
        return result.data;
    }

    static async getFileDownloadUrl(domain, path, expiresIn) {
        const params = {path};
        if (expiresIn !== undefined) {
            params.expiresIn = expiresIn;
        }
        const result = await axios.get(`${url}/FileIO/${domain}/get-download-url`, {params});
        return result.data;
    }

    static async commitBlob(commitUrl, body) {
        await axios.put(commitUrl, body);
    }

    static async execUploadUrlAzure(uploadUrl, chunk) {

        if (!uploadUrl) {
            throw new Error('missing url');
        }
        const blob = chunk instanceof File ? new Blob([chunk], { type: chunk.type }) : chunk;

        try {
            const response = await axios.put(uploadUrl, blob, {
                headers: {
                    "Content-Type": blob.type || "application/octet-stream"
                }
            });
            return response;
        } catch (error) {
            console.error('❌ FAILED');
            throw error;
        }
    }

    static async execUploadUrlGcloud(uploadUrl, chunk, firstByteIndex, lastByteIndex, totalSize) {
        if (!uploadUrl) {
            throw new Error('missing url');
        }
        console.log("uploadUrl", uploadUrl)
        console.log("chunk", chunk);
        try {

            await axios.put(uploadUrl, chunk, {
                headers: {
                    "Content-Type": "application/octet-stream",
                    "Content-Range": `bytes ${firstByteIndex}-${lastByteIndex}/${totalSize}`,

                }
            });
        } catch (e) {
            if (!e.response || e.response.status !== 308) {
                throw e;
            }
        }
    }

    static async associateFile(fileSize, fileUploadName, fileName, thumbnailUploadName, projectId, currentMediaFolder, storageFolderName, domain, oldMediaFile, isAiUpload) {
        const result = await axios.post(`${url}/FileIO/${domain}/AssociateFile`, {
            fileSize,
            fileUploadName,
            fileName,
            thumbnailUploadName,
            projectId,
            currentMediaFolder,
            storageFolderName,
            oldMediaFile,
            isAiUpload
        });
        return result.data;
    }

    static async deleteFile(fileId, domain) {
        const fileIdEncoded = GeneralRequester.encodeFileId(fileId);
        await axios.delete(`${url}/FileIO/${domain}/delete-file/?f=${fileIdEncoded}`)
    }

    static async deleteSessionMedia(fileId, domain, sessionId) {
        const fileIdEncoded = GeneralRequester.encodeFileId(fileId);
        await axios.put(`${url}/FileIO/${domain}/DeleteSessionMedia/${sessionId}/?f=${fileIdEncoded}`)
    }

    static encodeFileId(fileId) {
        return encodeURIComponent(fileId);
    }

    static async deleteFolder(folderId, domain) {
        await axios.delete(`${url}/FileIO/${domain}/DeleteFolder/${folderId}`)
    }

    static async renameMediaFolder(folderId, newName, domain) {
        const result = await axios.put(`${url}/FileIO/${domain}/RenameMediaFolder/${folderId}`, {newName});
        return result.status
    }

    static async renameFile(fileId, newName, domain) {
        const fileIdEncoded = GeneralRequester.encodeFileId(fileId);
        const result = await axios.put(`${url}/FileIO/${domain}/RenameFile/?f=${fileIdEncoded}`, {newName});
        return result.status
    }


    static async getMaxConnections(domain) {
        const result = await axios.get(`${url}/users/${domain}/get-max-connections`);
        return result.data
    }

    static async adminSearchUserSessions(userId, searchObj, domain) {
        const result = await axios.post(`${url}/users/${domain}/${userId}/AdminSearchUserSessions`, {
            ...searchObj
        });
        return result.data
    }

    static async adminSearchUserRemoteSessions(userId, searchObj, domain) {
        const result = await axios.post(`${url}/users/${domain}/${userId}/AdminSearchUserRemoteSessions`, {
            ...searchObj
        });
        return result.data
    }

    static async dataPoll(domain, userId) {
        const result = await axios.post(`${url}/users/${domain}/${userId}/dataPoll`); // sending userId for debug
        return result.data
    }

    static async getSSO(domain) {
        const res = await axios.get(`${url}/SSO/${domain}/GetSSO`);
        return res.data
    }

    static async updateSSO(Key, Description, TenantId, Signature, _id, isDefault, LogUrl, TokenUrl, UserInfoUrl) {
        return await axios.post(`${url}/SSO/${Key}/UpdateSSO`, {
            Key,
            Description,
            TenantId,
            Signature,
            _id,
            isDefault,
            LogUrl,
            TokenUrl,
            UserInfoUrl
        })
    }

    static async removeSSO(domain, _id) {
        return await axios.post(`${url}/SSO/${domain}/RemoveSSO`, {_id})
    }

    static async getPowerBiData(domain, apiKey, workspaceKey) {
        const res = await axios.get(`${url}/power-bi/${domain}/get-data/${apiKey}/${workspaceKey}`)
        return res.data
    }

    static async getPowerBiToken() {
        const res = await axios.get(`${url}/power-bi/get-token`)
        return res.data
    }

    static async getPowerBiApiKey(domain) {
        const res = await axios.get(`${url}/power-bi/${domain}/get-api-key`)
        return res.data
    }

    static async generatePowerBiApiKey(domain) {
        const res = await axios.get(`${url}/power-bi/${domain}/generate-api-key`)
        return res.data
    }

    static async removePowerBiApiKey(domain) {
        const res = await axios.get(`${url}/power-bi/${domain}/remove-api-key`)
        return res.data
    }


    static async getPlayerSettings(domain) {
        const result = await axios.get(`${url}/users/${domain}/GetPlayerSettings`);
        return result.data
    }

    static async updatePlayerSettings(
        webBackgroundColorRight, webBackgroundColorLeft, webBackgroundImageAddress,
        webIsBackgroundColor, mobileBackgroundColorTop, mobileBackgroundColorBottom, mobileTopBarColor,
        mobileBottomBarColor, mobileBackgroundImageAddress, mobileIsBackgroundColor, qrLogoImageAddress,
        qrBorderColor, qrTopImageAddress, domain) {
        await axios.put(`${url}/users/${domain}/UpsertPlayerSettings`, {
            webBackgroundColorRight,
            webBackgroundColorLeft,
            webBackgroundImageAddress,
            webIsBackgroundColor,
            mobileBackgroundColorTop,
            mobileBackgroundColorBottom,
            mobileTopBarColor,
            mobileBottomBarColor,
            mobileBackgroundImageAddress,
            mobileIsBackgroundColor,
            qrLogoImageAddress,
            qrBorderColor,
            qrTopImageAddress,
        });
    }

    static async getLatestFrontlineAR() {
        const downloadLink = isMacOs ? '/downloads/frontline-ar/getLatestAsDmg' : `/downloads/frontline-ar/getLatestAsMsi/${generalStore.workspaceIsHP || generalStore?.domainSettings?.IsHP}/${0}`
        const fileName = isMacOs ? 'FrontlineAR.dmg' : 'FrontlineAR.msi'
        const result = await axios.get(downloadLink);
        return {
            url: result.data,
            fileName
        };
    }

    static async disconnectDevice(signInData, deviceIndex) {
        const result = await axios.post(`${url}/users/DisconnectDevice`, {
            email: signInData.email,
            password: signInData.password,
            ssoAccessToken: signInData.ssoAccessToken,
            isHpCustomer: signInData.isHpCustomer,
            deviceIndex
        });
        return result.data
    }

    static async disconnectMyDevice(domain) {
        await axios.post(`${url}/users/${domain}/DisconnectMyDevice`);
    }


    static async getInviteEmail(domain, validationId) {
        const result = await axios.get(`${url}/users/${domain}/GetInviteEmail/${validationId}`);
        return result.data
    }

    static async verifyUser(email, password, firstName, lastName, verificationCode, deviceType) {
        const result = await axios.post(`${url}/users/verify`, {
            email,
            password,
            firstName,
            lastName,
            verificationCode,
            deviceType
        });
        return result.data
    }

    static async verifyAndCreateConventionUser(verificationCode, workspace, email, password, firstName, lastName, projectList, deviceType) {
        const result = await axios.post(`${url}/users/verify-and-create-convention-user`, {
            verificationCode, workspace, email, password, firstName, lastName, projectList, deviceType
        });
        return result.data
    }

    static async verifyResetPasswordToken(resetPasswordId) {
        const result = await axios.get(`${url}/users/get-email-by-token/${resetPasswordId}`); // bad naming for legacy reasons
        return result.data
    }

    static async getAllNotifications(domain) {
        const result = await axios.get(`${url}/notifications/${domain}/GetAllDomainNotifications`);
        return result.data
    }

    static async markAllNotificationsRead(domain, setToUnRead) {
        const result = await axios.put(`${url}/notifications/${domain}/UpdateUnreadAll`, {
            isUnread: setToUnRead
        });
        return result.data
    }

    static async updateNotification(domain, notification) {
        const result = await axios.put(`${url}/notifications/${domain}/update-notification`, {
            notification
        });
        return result.data
    }

    static async toggleUnread(domain, notificationId, isUnread) {
        const result = await axios.put(`${url}/notifications/${domain}/${notificationId}/UpdateUnread`, {
            isUnread
        });
        return result.data
    }

    static async getNewPushNotifications(domain) {
        const result = await axios.get(`${url}/notifications/${domain}/GetNewPushNotifications`);
        return result.data
    }

    static async disablePush(domain, notificationId) {
        const result = await axios.get(`${url}/notifications/${domain}/${notificationId}/DisableDesktopPush`);
        return result.status === responseEnum.OK
    }

    static async deleteNotificationsFromDate(domain, notificationIds) {
        const result = await axios.put(`${url}/notifications/${domain}/DeleteMany`, {
            notificationIds
        });
        return result.status === responseEnum.OK
    }

    static async deleteAllNotifications(domain) {
        const result = await axios.delete(`${url}/notifications/${domain}/AllDomain`);
        return result.status === responseEnum.OK
    }

    static async deleteNotification(domain, notificationId) {
        const result = await axios.delete(`${url}/notifications/${domain}/${notificationId}`);
        return result.status === responseEnum.OK
    }

    static async update3DAvatar(modelUrl, asRegularAvatar) {
        const result = await axios.put(`${url}/users/update-user-model`, {modelUrl, asRegularAvatar});
        return result.data;
    }

    static async delete3DAvatar() {
        const result = await axios.delete(`${url}/users/delete-user-model`);
        return result.data;
    }

    static async updateUserHand(isRight) {
        const result = await axios.put(`${url}/users/update-user-hand`, {isRight});
        return result.data;
    }


    static async updateUserLastLoginDate(workspace) {
        await axios.put(`${url}/users/${workspace}/update-login-date`);
    }

    static async getGlobalLanguage() {
        const result = await axios.get(`${url}/global-management/get-global-language`);
        return result.data;
    }

    static async sendAnalyticsEvent(eventName, workspace, eventParams) {
        await axios.post(`${url}/global-management/send-analytics-event`, {
            eventName,
            workspace,
            platform: 'Web',
            eventParams
        });
    }

    static async getDomainLanguage(domain) {
        const result = await axios.get(`${url}/global-management/get-domain-language/${domain}`);
        return result.data;
    }

    static async uploadDomainLanguage(domain, langArr) {
        const result = await axios.post(`${url}/global-management/upload-domain-language/${domain}`, {langArr});
        return result.data;
    }

    static async downloadDomainLanguage(domain) {
        const result = await axios.get(`${url}/global-management/download-domain-language/${domain}`);
        return result.data;
    }

    static async getAllPayPerClicks(db, filterObj) {
        const result = await axios.post(`${url}/ProcedureManagment/get-all-pay-per-clicks/${db}`, filterObj);
        return result.data;
    }

    static async getPayPerClickSessions(db, filterObj, payPerClickId) {
        const result = await axios.post(`${url}/ProcedureSessions/get-pay-per-click-sessions/${db}/${payPerClickId}`, filterObj);
        return result.data;
    }

    static async getPayPerClickSessionsChartData(db, filterObj, payPerClickId) {
        const result = await axios.post(`${url}/ProcedureSessions/get-pay-per-click-sessions-chart-data/${db}/${payPerClickId}`, filterObj);
        return result.data;
    }

    static async sendWebLogs(workspace, error, errorInfo) {
        await axios.post(`${url}/FileIO/${workspace}/send-web-logs`, {
            error,
            errorInfo,
            url: window.location.href
        });
    }

    static async saveAutoReportSettings(workspace, settingsObj) {
        const result = await axios.post(`${url}/users/update-auto-report-settings/${workspace}/`, settingsObj);
        return result.data
    }

    static async getAutoReportSettings(workspace, settingsObj) {
        const result = await axios.post(`${url}/users/get-auto-report-settings/${workspace}/`, settingsObj);
        return result.data
    }

    static async getWorkspaceConfig(workspace) {
        const {data} = await axios.get(`${url}/domains/${workspace}/get-domain-config`);
        return data;
    }

    static async getUploadUrlFastTrack(fileName, chunksCount, captchaToken, email, workspace) {
        const {data} = await axios.post(`${url}/FileIO/get-upload-url-fast-track`, {
            fileName, chunksCount, captchaToken, email, workspace
        });
        return data;
    }

    static async getUploadUrlFastTrackInternal(fileName, chunksCount, workspace, procedureId) {
        const {data} = await axios.post(`${url}/FileIO/get-upload-url-fast-track-internal`, {
            fileName, chunksCount, workspace, procedureId
        });
        return data;
    }

    static async finishUploadFastTrack(fileName, fileKey, uploadId, partsData, email, workspace, website, fileSizeInMB) {
        await axios.post(`${url}/FileIO/finish-upload-fast-track`, {
            fileName, fileKey, uploadId, partsData, email, workspace, website, fileSizeInMB
        });
    }

    static async finishUploadFastTrackInternal(fileName, fileKey, uploadId, partsData, workspace, procedureId, fileSizeInMB) {
        const {data} = await axios.post(`${url}/FileIO/finish-upload-fast-track-internal`, {
            fileName, fileKey, uploadId, partsData, workspace, procedureId, fileSizeInMB
        });
        return data
    }

    static async execUploadUrlS3(uploadUrl, chunk) {
        const {headers} = await axios.put(uploadUrl, chunk, {
                headers: {
                    "Content-Type": "application/octet-stream"
                }
            }
        );
        return headers.etag;
    }

    static async verifyFastTrack(code) {
        await axios.post(`${url}/FileIO/verify-fast-track`, {code});
    }

    static async getTempToken() {
        const response = await axios.get(`${url}/users/get-temp-token/`);
        return response.data
    }

    static async getDomainUsers(workspace, searchStr, ignoredIds) {
        const response = await axios.post(`${url}/users/${workspace}/search-users/`, {
            searchStr, ignoredIds
        });
        return response.data

    }

    static async getParentOrSubWorkspaceProjects(db, query, parentWorkspace) {
        const response = await axios.post(`${url}/domains/${db}/get-parent-or-sub-workspace-projects/`, {
            query,
            parentWorkspace: parentWorkspace ?? null
        });
        return response.data
    }

    static async createNewSubWorkspace(db, newDomainSettingsObj, ownerEmail) {
        const response = await axios.post(`${url}/domains/${db}/create-new-sub-workspace/`, {
            newDomainSettingsObj,
            ownerEmail
        });
        return response.data
    }
    static async updateMirroredProjects(db, subWorkspace, projectList, isDeleted) {
        const response = await axios.post(`${url}/domains/${db}/update-mirrored-projects/`, {
            subWorkspace,
            projectList,
            isDeleted
        });
        return response.data
    }

    static async updateSubWorkspaceSettings(db, newSubDomainSettings, isWorkspaceNameChanged, addedMaxUsersChanged) {
        const response = await axios.post(`${url}/domains/${db}/update-sub-domain-settings/`, {
            newSubDomainSettings,
            isWorkspaceNameChanged,
            addedMaxUsersChanged
        });
        return response.data
    }

    static async transferSubWorkspaceOwnership(db, subDomainName, previousOwner, newOwner, isHp) {
        const response = await axios.post(`${url}/domains/${db}/transfer-sub-workspace-ownership/`, {
            subDomainName,
            previousOwner,
            newOwner,
            isHp
        });
        return response.data
    }

    static async getSubWorkspaceOwner(db, subDomainName) {
        const response = await axios.post(`${url}/domains/${db}/get-sub-workspace-owner/`, {
            subDomainName
        });
        return response.data
    }
    static async getWorkspaceAdmins(db) {
        const response = await axios.get(`${url}/domains/${db}/get-workspace-admins/`);
        return response.data
    }

    static async deleteSubWorkspace(db, subDomainSettings, parentDomainSettings) {
        const response = await axios.post(`${url}/domains/${db}/delete-sub-workspace/`, {
            subDomainSettings,
            parentDomainSettings
        });
        return response.data
    }

    static async generateSubWorkspaceReport(db, currentMemberColumns, currentWorkspaceColumns) {
        const response = await axios.post(`${url}/domains/${db}/generate-sub-workspace-report/`, {
            currentMemberColumns,
            currentWorkspaceColumns
        });
        return response.data
    }

    static async saveSubWorkspaceReportSettings(db, domainSettings) {
        const response = await axios.post(`${url}/domains/${db}/save-sub-workspace-report-settings/`, {
            domainSettings
        });
        return response.data
    }

    static async getDomainNames(domainIdList) {
        const response = await axios.post(`${url}/domains/get-domain-names/`, domainIdList);
        return response.data
    }

    static async getOnlineUsers(usersIds) {
        const response = await axios.post(`${url}/users/get-online-users/`, usersIds);
        return response.data
    }

    static async updateOnline() {
        await axios.put(`${url}/users/update-online/`);
    }

    static async sendCreateWorkspaceRequest(email, firstName, lastName) {
        const response = await axios.post(`${url}/domains/send-create-workspace-request/`, {
            email,
            firstName,
            lastName
        });
        return response.data
    }

    static async generateLoginQR() {
        const response = await axios.post(`${url}/users/generate-login-qr/`);
        return response.data
    }

    static async deleteLoginQR() {
        const response = await axios.delete(`${url}/users/delete-login-qr/`);
        return response.data
    }

    static async createQrCode(db, qrCodeName) {
        const response = await axios.post(`${url}/qr-code/create-qr-code/${db}`, {
            qrCodeName
        })
        return response.data
    }

    static async getQrCodes(db, options) {
        const response = await axios.post(`${url}/qr-code/get-qr-codes/${db}`, {
            options
        })
        return response.data
    }

    static async deleteQrCode(db, qrCodeId) {
        const response = await axios.post(`${url}/qr-code/delete-qr-code/${db}`, {
            qrCodeId
        })
        return response.data
    }

    static async updateQrName(db, qrCodeId, qrCodeName) {
        const response = await axios.post(`${url}/qr-code/update-qr-name/${db}`, {
            qrCodeId,
            qrCodeName
        })
        return response.data
    }

    static async updateQrUrlLink(db, shortUrlId, shortUrlLink){
        const response = await axios.post(`${url}/qr-code/update-qr-link/${db}`, {
            shortUrlId,
            shortUrlLink
        })
        return response.data
    }

    static async getIsHpDomain(workspace) {
        const response = await axios.post(`${url}/domains/get-is-hp-domain`, {
            workspace
        });
        return response.data;
    }

    static async createIntegration(organization, organizationId, crm) {
        return await axios.post(`${url}/domains/${generalStore.workspace}/create-integration`, {
            organization,
            organizationId,
            crm
        });
    }

    static async getIntegrations() {
        const response = await axios.post(`${url}/domains/${generalStore.workspace}/get-integrations`);
        return response.data;
    }

    static async getGuestToken() {
        const response = await axios.post(`${url}/users/login-as-guest/`)
        return response.data;
    }

    static async updateTermsUrl(termsUrl) {
        const response = await axios.post(`${url}/domains/${generalStore.workspace}/update-terms-field`, {
            termsUrl
        });
        return response.data;
    }

    static async getAiCredits() {
        const response = await axios.post(`${url}/domains/${generalStore.workspace}/get-ai-credits`);
        return response.data;
    }
}
